module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "header",
    class: ['header', _vm.isUserPage ? 'transparent' : '']
  }, [_c('hamburger-icon', {
    attrs: {
      "back": _vm.shouldShowBackBtn()
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleClick($event)
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "brand-logo",
      "href": "https://www.github.com",
      "aria-label": "Brand Logo Link"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "notification-icon"
    }
  })], 1), _vm._v(" "), (_vm.showLoading) ? _c('loading-block', {
    attrs: {
      "done": _vm.doneLoading,
      "failed": _vm.loadFailed
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13e054e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBar.vue
// module id = 453
// module chunks = 2